<template>
<div :style="{'padding-left': `calc(${sidebarWidth} + 12px)`}" class="sidebar-content-wrapper">
  <div :style="{width: sidebarWidth}" class="sidebar">
    <div class="sidebar-panel" :style="`${isShowTit ? 'padding-top: 35px' : 'padding-top: 0;'}`">
      <div class="sidebar-header" v-if="isShowTit">
        <span class="sidebar-header-title">{{title}}</span>
        <div class="sidebar-header-toolbar"><slot name="silder-header-toolbar" /></div>
      </div>
      <div class="sidebar-body">
        <slot name="sidebar-body"></slot>
      </div>
    </div>
  </div>

  <div class="sidebar-content-body">
    <slot name="sidebar-content-body" />
  </div>
</div>
</template>

<script>
export default {
  name: 'SidebarContent',
  props: {
    title: {
      type: String
    },
    sidebarWidth: {
      type: String,
      default: '210px'
    },
    isShowTit: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;

  > .sidebar {
    position: absolute;
    top: 0;
    left: 12px;
    height: 100%;
  }

  > .sidebar-content-body {
    width: 100%;
    height: 100%;
    padding-left: .8rem;
  }

  .sidebar-panel {
    $TITLE-HEIGHT: 35px;

    position: relative;
    font-size: .875rem;
    width: 100%;
    height: 100%;
    padding-top: $TITLE-HEIGHT;
    user-select: none;

    > {
      .sidebar-header {
        position: absolute;
        display: grid;
        grid-template-columns: auto max-content;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: $TITLE-HEIGHT;
        line-height: $TITLE-HEIGHT;
        padding: {
          right: 10px;
          left: 10px;
        }
        border: 1px solid #EBEEF5 {
          bottom: 0;
        };
        background-color: #f9f9f9;
        color: #303133;
        font-weight: 700;
      }

      .sidebar-body {
        width: 100%;
        max-height: 100%;
        border: 1px solid #EBEEF5;
        overflow: auto;
      }
    }

    .sidebar-header-title {
      min: {
        width: 0;
      }
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  /deep/ {
    .sidebar-list {
      margin: 0;
      padding: 7px 0;
      color: #303133;

      .sidebar-item {
        padding: 8px 16px;
        cursor: pointer;

        &:hover {
          background-color: #ecf5ff;
          color: #66b1ff;
        }

        &.active {
          color: #66b1ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/SidebarContent.vue